export const routes = {};

export const SCHEMAS = {
  AUDIT: 'audit',
  CORE: 'core'
}

export const TABLES = {
  CUSTOMER: 'customer',
  CONTACT: 'contact',
  CUSTOMER_CONTACT_XREF: 'customer_contact_xref',
  INVOICE: 'invoice',
  INVOICE_LINE_ITEM: 'invoice_line_item',
  PROPERTY: 'property',
  SERVICE: 'service',
  TENANT: 'tenant',
  USER: 'user',
  WORKORDER: 'workorder',
}

export const JOIN_TYPES = {
  MANY_TO_ONE: 'ManyToOne',
  ONE_TO_MANY: 'OneToMany',
  MANY_TO_MANY: 'ManyToMany',
  ONE_TO_ONE: 'OneToOne'
}

export const ENTITY_METADATA = {
  TABLE: '_table',
  COLUMNS: '_columns',
  RELATIONSHIPS: '_relationships',
  ALLOWED_SORT_COLUMNS: '_allowed_sort_columns'
}

export const US_STATES = {
  ALABAMA: { unabbreviated: 'Alabama', ansi: 'AL', iso: 'US-AL' },
  ALASKA: { unabbreviated: 'Alaska', ansi: 'AK', iso: 'US-AK' },
  ARIZONA: { unabbreviated: 'Arizona', ansi: 'AZ', iso: 'US-AZ' },
  ARKANSAS: { unabbreviated: 'Arkansas', ansi: 'AR', iso: 'US-AR' },
  CALIFORNIA: { unabbreviated: 'California', ansi: 'CA', iso: 'US-CA' },
  COLORADO: { unabbreviated: 'Colorado', ansi: 'CO', iso: 'US-CO' },
  CONNECTICUT: { unabbreviated: 'Connecticut', ansi: 'CT', iso: 'US-CT' },
  DELAWARE: { unabbreviated: 'Delaware', ansi: 'DE', iso: 'US-DE' },
  DISTRICT_OF_COLUMBIA: { unabbreviated: 'District of Columbia', ansi: 'DC', iso: 'US-DC' },
  FLORIDA: { unabbreviated: 'Florida', ansi: 'FL', iso: 'US-FL' },
  GEORGIA: { unabbreviated: 'Georgia', ansi: 'GA', iso: 'US-GA' },
  HAWAII: { unabbreviated: 'Hawaii', ansi: 'HI', iso: 'US-HI' },
  IDAHO: { unabbreviated: 'Idaho', ansi: 'ID', iso: 'US-ID' },
  ILLINOIS: { unabbreviated: 'Illinois', ansi: 'IL', iso: 'US-IL' },
  INDIANA: { unabbreviated: 'Indiana', ansi: 'IN', iso: 'US-IN' },
  IOWA: { unabbreviated: 'Iowa', ansi: 'IA', iso: 'US-IA' },
  KANSAS: { unabbreviated: 'Kansas', ansi: 'KS', iso: 'US-KS' },
  KENTUCKY: { unabbreviated: 'Kentucky', ansi: 'KY', iso: 'US-KY' },
  LOUISIANA: { unabbreviated: 'Louisiana', ansi: 'LA', iso: 'US-LA' },
  MAINE: { unabbreviated: 'Maine', ansi: 'ME', iso: 'US-ME' },
  MARYLAND: { unabbreviated: 'Maryland', ansi: 'MD', iso: 'US-MD' },
  MASSACHUSETTS: { unabbreviated: 'Massachusetts', ansi: 'MA', iso: 'US-MA' },
  MICHIGAN: { unabbreviated: 'Michigan', ansi: 'MI', iso: 'US-MI' },
  MINNESOTA: { unabbreviated: 'Minnesota', ansi: 'MN', iso: 'US-MN' },
  MISSISSIPPI: { unabbreviated: 'Mississippi', ansi: 'MS', iso: 'US-MS' },
  MISSOURI: { unabbreviated: 'Missouri', ansi: 'MO', iso: 'US-MO' },
  MONTANA: { unabbreviated: 'Montana', ansi: 'MT', iso: 'US-MT' },
  NEBRASKA: { unabbreviated: 'Nebraska', ansi: 'NE', iso: 'US-NE' },
  NEVADA: { unabbreviated: 'Nevada', ansi: 'NV', iso: 'US-NV' },
  NEW_HAMPSHIRE: { unabbreviated: 'New Hampshire', ansi: 'NH', iso: 'US-NH' },
  NEW_JERSEY: { unabbreviated: 'New Jersey', ansi: 'NJ', iso: 'US-NJ' },
  NEW_MEXICO: { unabbreviated: 'New Mexico', ansi: 'NM', iso: 'US-NM' },
  NEW_YORK: { unabbreviated: 'New York', ansi: 'NY', iso: 'US-NY' },
  NORTH_CAROLINA: { unabbreviated: 'North Carolina', ansi: 'NC', iso: 'US-NC' },
  NORTH_DAKOTA: { unabbreviated: 'North Dakota', ansi: 'ND', iso: 'US-ND' },
  OHIO: { unabbreviated: 'Ohio', ansi: 'OH', iso: 'US-OH' },
  OKLAHOMA: { unabbreviated: 'Oklahoma', ansi: 'OK', iso: 'US-OK' },
  OREGON: { unabbreviated: 'Oregon', ansi: 'OR', iso: 'US-OR' },
  PENNSYLVANIA: { unabbreviated: 'Pennsylvania', ansi: 'PA', iso: 'US-PA' },
  RHODE_ISLAND: { unabbreviated: 'Rhode Island', ansi: 'RI', iso: 'US-RI' },
  SOUTH_CAROLINA: { unabbreviated: 'South Carolina', ansi: 'SC', iso: 'US-SC' },
  SOUTH_DAKOTA: { unabbreviated: 'South Dakota', ansi: 'SD', iso: 'US-SD' },
  TENNESSEE: { unabbreviated: 'Tennessee', ansi: 'TN', iso: 'US-TN' },
  TEXAS: { unabbreviated: 'Texas', ansi: 'TX', iso: 'US-TX' },
  UTAH: { unabbreviated: 'Utah', ansi: 'UT', iso: 'US-UT' },
  VERMONT: { unabbreviated: 'Vermont', ansi: 'VT', iso: 'US-VT' },
  VIRGINIA: { unabbreviated: 'Virginia', ansi: 'VA', iso: 'US-VA' },
  WASHINGTON: { unabbreviated: 'Washington', ansi: 'WA', iso: 'US-WA' },
  WEST_VIRGINIA: { unabbreviated: 'West Virginia', ansi: 'WV', iso: 'US-WV' },
  WISCONSIN: { unabbreviated: 'Wisconsin', ansi: 'WI', iso: 'US-WI' },
  WYOMING: { unabbreviated: 'Wyoming', ansi: 'WY', iso: 'US-WY' },
  PUERTO_RICO: { unabbreviated: 'Puerto Rico', ansi: 'PR', iso: 'US-PR' },
};

export type USStateKey = keyof typeof US_STATES;
export type USStateValue = (typeof US_STATES)[USStateKey];

export function parseUSState(input: string | null | undefined): USStateValue | null {
  if (!input) return null;

  const normalized = input.trim().toLowerCase();

  for (const state of Object.values(US_STATES)) {
    if (
      state.unabbreviated.toLowerCase() === normalized ||
      state.ansi.toLowerCase() === normalized ||
      state.iso.toLowerCase() === normalized
    ) {
      return state;
    }
  }

  return null;
}

export const STATE_OPTIONS = Object.values(US_STATES);